<div class="row">
  <div class="col-12 text-right icon-mat-close">
    <i mat-dialog-close class="bi bi-x" (click)="closeDialog()"></i>
  </div>
  <div class="custom-card extend-card">
    <div class="col-12">
  <div class="col-12 text-right max-charges-cont">
    <p>** {{ selection.selected.length }} of 5 Maximum limit of charges.</p>
  </div>
      <table mat-table class="tabletop" [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <ng-container>
              <!--
                <mat-checkbox
                (change)="$event ? toggleAllRows() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
              -->
            </ng-container>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container>
              <mat-checkbox
                [disabled]="selection.selected.length == 5 && row.selected == false"
                class="checkbox-select mt-2 mr-1"
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="type_code">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Charge Code</th>
          <td mat-cell *matCellDef="let element">{{ element?.type_code }}</td>
        </ng-container>
        <ng-container matColumnDef="type_label">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Charge/Fee/Cost</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.type_label }}
          </td>
        </ng-container>
        <ng-container matColumnDef="type_value">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Value</th>
          <td mat-cell *matCellDef="let element">
            <input
              [disabled]="!element.selected"
              class="input-value form-control"
              type="number"
              min="0"
              [(ngModel)]="element.type_value"
              [value]="element?.type_value"
              appTwoDigitDecimaNumber />
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>

</div>
